import React from "react";
import Footer from "./Footer";

import EmailIcon from "@material-ui/icons/Email";
import LanguageIcon from "@material-ui/icons/Language";
const PaymentInformation = ({
  pageNumber,
  totalPages
}) => {
  return (
    <div className="invoice-page">

      {/* Header */}

      <div className="payment-header">

        <div>

          <h2 className="payment-title">
            PAYMENT INFORMATION
          </h2>

        </div>

      </div>

      {/* Body */}

      <div className="payment-content">

        {/* LEFT */}

        <div className="payment-left">

          <div className="section">

            <h3>Payment shall be made to:</h3>

            <p><strong>LEÓN GALLERY</strong></p>

          </div>

          <div className="section">

            <h4>METROBANK</h4>

            <table className="bank-table">

              <tbody>

                <tr>

                  <td>Account Name</td>

                  <td>LEÓN GALLERY</td>

                </tr>

                <tr>

                  <td>Account Number</td>

                  <td>166-7166-52009-2</td>

                </tr>

                <tr>

                  <td>Branch</td>

                  <td>Corinthian Plaza</td>

                </tr>

              </tbody>

            </table>

          </div>

          <div className="section">

            <h4>UNIONBANK</h4>

            <table className="bank-table">

              <tbody>

                <tr>

                  <td>Account Name</td>

                  <td>LEÓN GALLERY</td>

                </tr>

                <tr>

                  <td>Account Number</td>

                  <td>0000-0000-0000</td>

                </tr>

                <tr>

                  <td>Branch</td>

                  <td>Makati</td>

                </tr>

              </tbody>

            </table>

          </div>

        </div>

        {/* RIGHT */}

        <div className="payment-right">

          <div className="section">

            <h3>IMPORTANT NOTICE</h3>

            <ul>

              <li>
                Payments must be completed within the prescribed payment period.
              </li>

              <li>
                Storage charges may apply after the allowable claiming period.
              </li>

              <li>
                Please indicate your Invoice Number on bank transfers.
              </li>

            </ul>

          </div>

          <div className="section">

            <h3>CLAIMING PURCHASED LOTS</h3>

            <table className="claim-table">

              <thead>

                <tr>

                  <th>Category</th>

                  <th>Location</th>

                </tr>

              </thead>

              <tbody>

                <tr>

                  <td>Jewelry and coins</td>

                  <td>Eurovilla I</td>

              </tr>
 <tr>
                  <td>Paintings,Furniture</td>

                  <td>La Fuerza Plaza</td>

                </tr>

               
              </tbody>

            </table>

          </div>

         <div className="contact-section">

    <div className="payment-title">

        

        <h2> CONTACT INFORMATION</h2>

    </div>

    <p>For questions or inquiries, please call:</p>

   <p><strong>Eurovilla 1 :</strong> 8856-2781</p>

    <div className="contact-divider"></div>

    <div className="contact-item">
        <LanguageIcon fontSize="small" />
        <span>www.leon-gallery.com</span>
    </div>

    <div className="contact-item">
        <EmailIcon fontSize="small" />
        <span>info@leon-gallery.com</span>
    </div>
 <div className="contact-item">
        <EmailIcon fontSize="small" />
        <span>leongallerymakati@gmail.com</span>
    </div>
    </div>


        </div>

      </div>

      <Footer
        pageNumber={pageNumber}
        totalPages={totalPages}
      />

    </div>
  );
};

export default PaymentInformation;